// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const UnoCreatePlanModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-createplanmodalcontainer" */ "./UnoCreatePlanModalContainer")).then((bundle)=>{
        return {
            default: bundle.UnoCreatePlanModalContainer
        };
    });
export const LazyUnoCreatePlanModalContainer = /*#__PURE__*/ lazy(UnoCreatePlanModalContainerLazyLoader);
